export enum SearchResultItemType {
  AttributeResult = 1,
  Measurement = 2
}
